import script from "./web-index.vue?vue&type=script&setup=true&lang=js"
export * from "./web-index.vue?vue&type=script&setup=true&lang=js"

import "./web-index.vue?vue&type=style&index=0&id=0c29cf31&lang=scss"

const __exports__ = script;

export default __exports__